import classNames from 'classnames/bind';
import { useTranslation } from 'react-i18next';

import { Icon } from '@/components/shared/Icon';
import { useDropdownContext } from '@/contexts/shared/DropdownContext';

import type { SavedFiltersTriggerState } from './resolveSavedFiltersTriggerState';
import style from './SavedFilters.module.sass';

const cx = classNames.bind(style);

type SavedFiltersTriggerProps = {
  state: SavedFiltersTriggerState;
};

export const SavedFiltersTrigger = ({
  state,
}: SavedFiltersTriggerProps) => {
  const { t } = useTranslation();
  // The open state comes from the context rather than a render-prop trigger, so the dropdown keeps
  // wrapping this in its own button and the click and keyboard handling stay where they were.
  const { isOpen } = useDropdownContext();

  const triggerValue = () => {
    if (state.kind === 'applied' || state.kind === 'edited') return state.presetName;

    if (state.kind === 'idle') return t('savedFilters:noPresetApplied');

    return t('savedFilters:noPresetsSaved');
  };

  return (
    <span className={style.triggerContainer}>
      <span className={style.presetTriggerCopy}>
        <span className={style.presetTriggerLabel}>{t('savedFilters:filterPresetLabel')}</span>
        <div className={cx('presetTriggerValue', { isOpen })}>
          <span className={style.presetTriggerName}>{triggerValue()}</span>
          {state.kind === 'edited' ? (
            <span className={style.presetTriggerEditedSuffix}>
              {t('savedFilters:editedSuffix')}
            </span>
          ) : null}
          <Icon name='ChevronDown' className={style.presetTriggerChevron} />
        </div>
      </span>
    </span>
  );
};
